 import 'magnific-popup/dist/jquery.magnific-popup.min.js';

 $(document).ready(function() {
       $('.popup-youtube').magnificPopup({
    type: 'iframe'

	});
});
